import { Dialog } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import { useRef } from "react";

const EFILE_CONFIRM_STEP = "efile";
const COMPLETE_ONLY_STEP = "completeOnly";

const EfileCompletionConfirmationModal = ({
    open,
    step,
    isCompletingService,
    isUpdatingEfile,
    onUpdateAndComplete,
    onCompleteOnly,
    onConfirmCompleteOnly,
    onGoBack,
    onCancel,
}) => {
    const primaryButtonRef = useRef(null);
    const isSaving = isCompletingService || isUpdatingEfile;
    const isCompleteOnlyStep = step === COMPLETE_ONLY_STEP;

    return (
        <AnimatePresence>
            {open && (
                <Dialog
                    initialFocus={primaryButtonRef}
                    static
                    as={motion.div}
                    open={open}
                    onClose={() => {
                        if (!isSaving) onCancel();
                    }}
                    className="relative z-50"
                >
                    <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

                    <div className="fixed inset-0 w-screen overflow-y-auto">
                        <div className="flex items-center justify-center min-h-full p-4">
                            <Dialog.Panel className="relative w-full px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-md sm:p-6">
                                <div className="text-center">
                                    <Dialog.Title className="w-full text-lg font-medium leading-6 text-center text-gray-900">
                                        {isCompleteOnlyStep
                                            ? "Complete service"
                                            : "Update E-file status"}
                                    </Dialog.Title>
                                    <p className="mt-3 text-sm text-gray-500">
                                        {isCompleteOnlyStep
                                            ? "Are you sure you want to complete this service?"
                                            : "Do you want to update the E-file status to Accepted?"}
                                    </p>
                                </div>

                                {step === EFILE_CONFIRM_STEP && (
                                    <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3">
                                        <button
                                            ref={primaryButtonRef}
                                            type="button"
                                            disabled={isSaving}
                                            onClick={onUpdateAndComplete}
                                            className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-teal-500 border border-transparent rounded-md shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-60 sm:text-sm"
                                        >
                                            Yes, update and complete
                                        </button>
                                        <button
                                            type="button"
                                            disabled={isSaving}
                                            onClick={onCompleteOnly}
                                            className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-60 sm:mt-0 sm:text-sm"
                                        >
                                            No, complete only
                                        </button>
                                        <button
                                            type="button"
                                            disabled={isSaving}
                                            onClick={onCancel}
                                            className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-60 sm:col-span-2 sm:text-sm"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                )}

                                {step === COMPLETE_ONLY_STEP && (
                                    <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                        <button
                                            ref={primaryButtonRef}
                                            type="button"
                                            disabled={isSaving}
                                            onClick={onConfirmCompleteOnly}
                                            className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-teal-500 border border-transparent rounded-md shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-60 sm:col-start-2 sm:text-sm"
                                        >
                                            Yes, complete service
                                        </button>
                                        <button
                                            type="button"
                                            disabled={isSaving}
                                            onClick={onGoBack}
                                            className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-60 sm:mt-0 sm:col-start-1 sm:text-sm"
                                        >
                                            Go back
                                        </button>
                                    </div>
                                )}
                            </Dialog.Panel>
                        </div>
                    </div>
                </Dialog>
            )}
        </AnimatePresence>
    );
};

export default EfileCompletionConfirmationModal;
